import React, { useReducer, useContext, useEffect, useMemo } from 'react';
import DefaultModal from '../Utils/DefaultModal';
import { lockedReducer } from '../Utils/reducers';
import { Box, TextField, Tooltip } from '@mui/material';
import { api } from '../../services/api';
import { externalComponent } from '../AppRoutes';
import validateDataTable from './validateCopyTable';
import ColorButton from '../Buttons/ColorButton';
import Table from '../Table';
import { NumericFormatInput } from '../Utils/NumericInput';
import { formatCurrency } from '../Utils/IntegerOnly';
import { PercentFormatInputDefault } from '../Utils/PercentInputDefault';
import MegaAutoComplete from '../Utils/megautocomplete';
import toast from 'react-hot-toast';

const copyTable = async (setLoader, data, setState, getTables, handleClose) => {
    setLoader(true)
    const res = await api.post(`/tabelas/copia-tabela/`, data)
    if (res.status === 200) {
        getTables(setLoader, setState)
    } else {
        toast.error(res.message)
    }
    setLoader(false)
    handleClose()
}


const changePrice = (props, value) => {
    props.row.preco = value * 100
    props.api.forceUpdate()
}

const loadRetrieve = async (id, setState, setLoader) => {
    setLoader(true)
    const res = await api.get('/tabelas/' + `${id}/`)
    if (res.status === 200) {
        setState({ ...res.data })
    }
    setLoader(false)
}

const getProdutos = async (setLoader, setState, data) => {
    setLoader(true)
    const res = await api.get(`/tabelas/produtos/${data.id}`)
    setLoader(false)
    if (res.status === 200) {
        setState({ rows: res.data, rowsReset: res.data })
    }
}

const changeAllPrices = (setState, state, value, teste) => {
    const ativo = teste
    let updatedRows = []
    if (ativo) {
        updatedRows = state?.rowsReset.map(row => ({
            ...row,
            preco: row.preco * (100 + value) / 100
        }));

    } else {

        updatedRows = state?.rowsReset.map(row => ({
            ...row,
            preco: row.preco / value
        }));

    }

    setState({ rows: updatedRows })

}

const getcolumns = (setState, state) => {
    const columns = []
    columns.push({ field: 'Cod', headerName: 'Código', width: 100 })
    columns.push({ field: 'Descricao', headerName: 'Descrição', flex: 1 })
    columns.push({
        field: 'preco', headerName: 'Preço', width: 200,
        renderCell: (props) => {
            return (

                <Box sx={{ width: '90%' }}>
                    <TextField
                        id="valor"
                        type="text"
                        value={props.value / 100}
                        onChange={(e) => changePrice(props, e.target.value)}
                        fullWidth={false}
                        size='small'
                        sx={{ fontSize: '13px' }}
                        onKeyDown={(e) => e.stopPropagation()}
                        InputProps={{
                            inputComponent: NumericFormatInput,
                            sx: { fontSize: '13px' }
                        }}
                    />
                </Box>
            )
        }
    })
    columns.push({
        field: 'preco_minimo', headerName: 'Preço mínimo', width: 150,
        renderCell: ({ row }) => {

            let preco_minimo = (row.preco / 10000) * (100 - state.preco_minimo)
            return (
                <Box sx={{ width: '90%' }}>
                    {formatCurrency(preco_minimo)}
                </Box>
            )
        }
    })


    return columns
}

const changeComplete = (data, setState, state) => {
    if (state.grupo_filial.length === 0) {
        const nome = data[0].data.default_name
        setState({ nome: nome })
    }
    setState({ grupo_filial: data })

}

const CopyTableModal = ({ data, handleClose, reloadData }) => {

    const [state, setState] = useReducer(lockedReducer, {
        rows: [],
        rowsReset: data.rows,
        ativo: true,
        porcentagem: 0,
        nomeTabela: data.nome,
        grupo_filial: [],

        ...data,
        id: data.id ? data.id : 0

    })


    const { setLoader } = useContext(externalComponent)
    const validTable = validateDataTable(state)


    useEffect(() => {

        if (data.id)
            loadRetrieve(data.id, setState, setLoader)
        getProdutos(setLoader, setState, data)
    }, [setLoader, data.id])

    return (
        <>
            <DefaultModal
                dialogProps={{ maxWidth: "xl" }}
                handleClose={handleClose}
                open={true}
                title={`Criar cópia da tabela ${data.nome} ?`}
                content={

                    <Box className='item-content-modal noborder'>

                        <Box sx={{ display: 'flex', flexDirection: 'row', gap: '1rem', alignItems: 'flex-end' }}>

                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>

                                <TextField
                                    id="porcentagem"
                                    type="text"
                                    label="Porcentagem"
                                    value={state.porcentagem}
                                    onChange={(e) => { setState({ 'porcentagem': e.target.value }); changeAllPrices(setState, state, e.target.value, state.ativo) }}
                                    onBlur={(e) => { changeAllPrices(setState, state, state.porcentagem, state.ativo) }}
                                    fullWidth={false}
                                    size='small'
                                    inputProps={{
                                        maxLength: 50
                                    }}
                                    InputProps={{
                                        inputComponent: PercentFormatInputDefault,
                                    }}
                                    sx={{ width: '100%' }}
                                />
                            </Box>

                            <TextField
                                id="nometabela"
                                type="text"
                                label="Nome da tabela"
                                size='small'
                                value={state.nomeTabela}
                                onChange={(e) => { setState({ nomeTabela: e.target.value }) }}
                                fullWidth={false}
                                sx={{ width: '20%' }}
                            />

                            <MegaAutoComplete
                                multiple={true}
                                value={state.grupo_filial}
                                onChange={(data) => changeComplete(data, setState, state)}
                                noOptionsText={'Digite para procurar uma Filial'}
                                timeoutUrl='/tabela/grupo_filial/'
                                timeoutParam='label'
                                label='Grupo filial'
                                sx={{ width: '20%' }}
                            />

                        </Box>

                        <Box sx={{ width: '100%', height: '24rem' }}>
                            <Table
                                paginationMode='client'
                                className='contabil-grid'
                                rows={state.rows}
                                columns={useMemo(() => getcolumns(setState, state), [state.rows, state.edit])}
                                pagination={false}
                                rowHeight={30}
                                disableRowSelectionOnClick={true}
                                toolbar
                                sx={{
                                    maxHeight: "24rem"
                                }}
                            />
                        </Box>

                    </Box>

                }

                action={
                    <Tooltip title={validTable} placement="left">
                        <span>
                            <ColorButton disabled={validTable} onClick={() => copyTable(setLoader, state, setState, reloadData, handleClose)}>Salvar</ColorButton>
                        </span>
                    </Tooltip>
                }
            />

        </>
    )
}

export default CopyTableModal;